import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-platform-modal',
  templateUrl: './edit-platform-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-platform-modal.component.scss']
})
export class EditPlatformModalComponent {
  public platformForm: FormGroup
  public isSuccess : boolean = false
  public isLoading : boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditPlatformModalComponent>,
    @Inject(MAT_DIALOG_DATA) public platformData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService : WellHeaderInfoService
    ) { }

  ngOnInit() {
    this.platformForm = this.initializeForm()

    this.platformForm.get('platformShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.platformForm.get('platformShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      id: this.platformData.platformId,
      fieldId: this.platformData.fieldId,
      platformShortName: [this.platformData.name, [Validators.required, noWhitespaceValidator()]],
      platformLongName: [this.platformData.longName, [Validators.required, noWhitespaceValidator()]],
      platformStatus: this.platformData.status,
      remark: this.platformData.remarks,
    })
  }

  updatePlatform() {
    this.wellHeaderInfoService.updatePlatform(this.platformForm.value).subscribe({
      next: (res) => {
        if(res.isSuccess){
          this.isSuccess = true
          this.closeDialog()
        }

        this.isLoading = false
      },
      error: (err) => this.isLoading = false
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get platformShortName() {
    return this.platformForm.get('platformShortName');
  }

  get platformLongName() {
    return this.platformForm.get('platformLongName');
  }
}
